import { BlockedContainer } from './BlockedContainer';

export interface BlockedContainerProps extends React.HTMLAttributes<HTMLDivElement> {
	// Центрировать ли контейнер
	center?: boolean;
	// Показывать ли контейнер на всей странице
	isFullScreen?: boolean;
	// Callback при закрытии контейнера
	onRequestClose?: () => void;
	// Callback при клике на overlay
	onOverlayClick?: () => void;
	// Callback при нажатии на Esc
	onEsc?: () => void;
}

export default BlockedContainer;
